import forEach from 'lodash/forEach';
export class ComponentsBinder {
    constructor(_componentIncludes, _componentsList) {
        this.componentIncludes = _componentIncludes;
        this.componentsList = _componentsList;
        if (global.components === null || typeof global.components === "undefined") {
            global.components = new Map();
        }
    }
    getComponentObjectByName(name) {
        var index = this.componentsList.indexOf(name);
        if (index == -1) {
            return null;
        }
        return this.componentIncludes[index];
    }
    bindComponentsToDom() {
        for (var c of this.componentsList) {
            var componentElements = document.querySelectorAll(`.${c}`);
            if (componentElements.length > 0) {
                var _c = c;
                forEach(componentElements, function (elm, i) {
                    var componentName = _c;
                    var componentId = `${componentName}_${i}`;
                    var componentObject = this.getComponentObjectByName(componentName);
                    var component = new componentObject(elm, componentId);
                    global.components.set(componentId, component);
                }.bind(this));
            }
        }
    }
}
//# sourceMappingURL=componentsBinder.js.map